import { render } from "./ViewCustomers.vue?vue&type=template&id=0c91a4ee"
import script from "./ViewCustomers.vue?vue&type=script&lang=js"
export * from "./ViewCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__